// DO NOT EDIT -- generated from fs/services/pinguin/model.proto

import * as protobuf from '../../../google/protobuf';

/** The Facility is the "feature" or part of the app that sends similar notifications. */
export enum Facility {
  FACILITY_INVALID = 0,
  METRIC_ALERTS = 1,
  /** Notifications related to a user's account and subscription */
  ACCOUNT_MANAGEMENT = 2,
  /**
   * We aren't currently creating Segment notifications on the backend,
   * but we need this facility in order to merge the old segment alerts in the UI.
   */
  SEGMENT_ALERTS = 3,
  /** At mention notifications. */
  NOTES = 4,
  /** Wayfinder notifications. */
  WAYFINDER = 5,
  /** Opportunities notifications. */
  OPPORTUNITIES = 6
}

/**
 * The unique identifier of a NotificationConfig, which is also used to specify the config
 * for each Notification.
 */
export interface ConfigID {
  facility: Facility;
  /** A unique ID provided by the Facility. */
  triggerId: string;
}

/**
 * A destination that a notification can be sent to.
 * Can be either an individual user or a third-party app
 */
export interface Recipient {
  bot?: BotRecipient | null;
  user?: UserRecipient | null;
}

/**
 * A destination that a notification can be sent to.
 * Can be either an individual user or a third-party app
 */
export namespace Recipient {
  export enum recipient {
    bot = 1,
    user = 2
  }

  export function recipient_oneof(m: Recipient): { opt: recipient.bot, val: BotRecipient } | { opt: recipient.user, val: UserRecipient } | null {
    if (m.bot != null) { return { opt: recipient.bot, val: m.bot } }
    if (m.user != null) { return { opt: recipient.user, val: m.user } }
    return null;
  }
}

/** A third-party integration that can receive notifications */
export interface BotRecipient {
  /** An ID provided by Emissary that links to a configured destination for the above integration. */
  destinationId: string;
  /** The user who configured this particular recipient */
  createdBy: string;
}

/** If and how the user wants to receive email notifications */
export enum EmailOption {
  DISABLED = 0,
  IMMEDIATE = 1
}

/**
 * A user who wants to receive notifications. This user will always see the associated
 * notifications in-app, and can opt in to other methods of receiving it.
 */
export interface UserRecipient {
  /** The email of the subscribed user */
  user: string;
  /** Whether the user wants to receive an email. */
  sendEmail: EmailOption;
  /**
   * When true, user recipient will not receive in-app notifications and the notification will not appear in the user's
   * sidecar. Note that when this is true, no record of the notification for this user is saved to datastore.
   * The only record that an email notification was sent to a user will be available via SendGrid, which only stores
   * these records for 30 days.
   */
  optOutOfInApp: boolean;
}

/** The stored configuration for a given ConfigID. Used to determine who to send Notifications to. */
export interface NotificationConfig {
  /** Unique identifier for this config */
  configId: ConfigID | null;
  /** The recipients for each Notification instance associated with this Config */
  recipients: Recipient[];
  /** The user who created the Config. */
  createdBy: string;
  createdAt: protobuf.timestamp | null;
}

/** Represents a Notification that was sent and the Recipients who received it. */
export interface Notification {
  id: string;
  /** May link to a NotificationConfig, although it is possible that none exists. */
  configId: ConfigID | null;
  /** When the Notification was created/sent */
  createdAt: protobuf.timestamp | null;
  /** If clustering, this represents the number of time this Notification has occurred. */
  count: number;
  /** Where this Notification was sent. */
  botNotifications: BotNotification[];
  /** True if the message has been marked read by the requesting user */
  read: boolean;
  /** The message content of the notification */
  content: NotificationContent | null;
}

/** Should map to the keys in JSON templates. */
export interface NotificationContent {
  title: string;
  preheader: string;
  content: string;
  ctaLabel: string;
  ctaUrl: string;
}

export interface BotNotification {
  /** An ID provided by Emissary that links to a configured destination for the above integration. */
  destinationId: string;
}
